export const userPrefersReducedMotion = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//# sourceMappingURL=prefersReducedMotion.js.map